module.exports = __webpack_public_path__ + "img/1419275869.b9fc5206.jpg";